import React, { useEffect, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, TextField
} from '@material-ui/core'
import { Alert, } from '@material-ui/lab';
import SelectCompany from '../../components/SelectCompany';
import CompanyApi from '../../services/company.service';
import SettingsApi from '../../services/settings.service';
import { CHECK_NON_EMPTY_ARRAY } from '../../common/data-validator';
import { Autocomplete } from '@mui/material';
import { Label } from 'semantic-ui-react';

export default function FpFormTemplateId() {
    const [fpFormId, setFpFormId] = useState();
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const [fpForms, setFpForms] = useState([]);
    const apiservices = new CompanyApi();
    const settingServices = new SettingsApi();
    const [selectedCompany, setSelectedCompany] = useState<any>(null);
    const [templateId, setTemplateId] = useState();

    const handleChange = async (e: any, value: any) => {
        setFpFormId(value.value);
    }

    useEffect(()=>{
        fetchFpForms();
    },[selectedCompany?.value])

    const fetchFpForms = async () =>{
        const forms: any = await apiservices.getFPformList() || [];
        let fpForms: any = [];
        forms.forEach((form: any)=>{
            let fpFormObj = {
                value : form.id,
                title: form.name
            }
            fpForms.push(fpFormObj)
        })
        setFpForms(fpForms);
    }

    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Deletion Cancelled.`);
    }
    const onClose = () => {
        setErrorDialog(false)
    }
    const handleTemplateIdChange = (e: any) => {
        setTemplateId(e.target.value);
    }

    const onAdd = async () => {
        try {
            let companyId = localStorage.getItem("selectedCompanyId");
            const payload = {
                id : fpFormId,
                template: templateId
            }
            let response = await apiservices.templateId(payload);
            
            if (response) {
                setDialog(false);
                setSnackBar("success");
                setPageResponse("Added Successfully.");
            }
            else{
                setDialog(false);
                setSnackBar("error");
                setPageResponse(`Process Failed`);
            }
        } catch (error) {
            setDialog(false);
            setSnackBar("error");
            setPageResponse(`Process Failed, error: ${error}`);
            return;
        }
    };

    return (
        <>
            <SRCards />
            <Container>
                <Button
                    onClick={onAdd}
                    style={{ marginBottom: 40 }}
                    variant='outlined'> Add </Button>
                {/* <br></br><br></br><br></br> */}
                <FormControl fullWidth className='rediscache_body'>
                <Label id="demo-simple-select-label">Company</Label>
                <SelectCompany optionHandler={setSelectedCompany}/>
                <br></br>
                    <Label id="demo-simple-select-label">Fp Forms</Label>
                    {/* <Select
                        onChange={handleChange}
                    >
                        { CHECK_NON_EMPTY_ARRAY(fpForms) && fpForms.forEach((fpForm: any)=>{
                            <MenuItem value={fpForm.id}>{fpForm.name}</MenuItem>
                        }) 
                         }
                    </Select> */}
                    <Autocomplete
                    id="combo-box-demo"
                    options={fpForms}
                    getOptionLabel={
                        (option: any) => option.title
                    }
                    // getOptionSelected={
                    //     (option, value) => option.title === value.title
                    // }
                    onChange={(e,value)=>{handleChange(e,value)}}
                    value={fpFormId}
                     renderInput={(params) =>
                        <TextField {...params}
                            placeholder="FP Forms"
                            variant="outlined" />}
                />
                </FormControl>
                <br /> <br /><br></br>
                    <> 
                        <TextField
                            fullWidth
                            id="outlined-multiline-static"
                            label="Template ID"
                            value={templateId}
                            multiline
                            rows={1}
                            variant="outlined"
                            onChange={handleTemplateIdChange} />
                    </>
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please provide the details before proceeding.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}